<template>
    <v-expansion-panels 
            :value="[expand]"
            multiple
            class="panels-flat">
        <!-- Countries -->
        <v-expansion-panel>
            <v-expansion-panel-header class="primary--text py-1">{{localName}}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-text-field
                v-model="search"
                :label="`Find ${localName}`"
                dense
                outlined
                hide-details
                v-if="localItemList.length > localInitialCount"
                ></v-text-field>
                <v-list dense class="custom-truncate-list-label">
                <v-list-item
                    v-for="item in displayedList(localItemList, showAllItems, search, localInitialCount)"
                    :key="item.name"
                    class="list-item-small pa-0"
                >
                    <v-list-item-action>
                        <v-checkbox
                            v-model="item.selected"
                            @change="toggle(localSelectedItems, item.id)"
                            hide-details
                            dense
                            class="custom-truncate-label"
                        >
                        
                        <template #label >
                            <!-- Apply classes to an element inside the label slot -->
                            <span  >
                                {{item.name}}
                            </span>
                        </template>
                        </v-checkbox>
                    </v-list-item-action>
                </v-list-item>
                </v-list>
                <a href="#" @click.prevent="loadAll" v-if="!showAllItems && localItemList.length > localInitialCount">Show all {{localName}}</a>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>

import { ref, computed, watch, onMounted } from '@vue/composition-api'

export default {
    props: {
        filterName: {
            type: String,
        },
        itemList: {
            type: Array
        },
        initialCount: {
            type: Number
        },
        selectedItems: {
            type: Array
        },
        loading: {
            type:Boolean
        },
        expand: {
            type: Number,
            default: 0
        }
    },
    setup(props, { emit }) {

        const localName = ref("")
        const search = ref("")
        const showAllItems = ref(false)
        const localItemList = ref([])
        const localInitialCount = ref(7)
        const localSelectedItems = ref([])
        const localLoading = ref(false)

        const init = () => {
            localName.value = props.filterName
            localItemList.value = props.itemList
            localInitialCount.value = props.initialCount
            localSelectedItems.value = props.selectedItems
            localLoading.value = props.loading
            // if (props.itemList.length == 0) expand.value = 1
        }

        const toggle = (selection, value) => {
            const index = selection.indexOf(value);
            emit('update', true)
            if (index > -1) {
                selection.splice(index, 1); // Remove if already selected
            } else {
                selection.push(value); // Add if not selected
            }
        }

        const isSelected = (selection, value) => {
            if (selection) {
                return selection.includes(value);
            }
        }


        const displayedList = computed(() => {
            return (originalList, showAll=true, searchTerm='', initialCount=999) => {
                if (showAll) {
                    return filteredList.value(originalList, searchTerm);
                } else {
                    return filteredList.value(originalList, searchTerm).slice(0, initialCount);
                }
            }
        })

        const filteredList = computed(() => {
            return (originalList, searchTerm) => {
                
                searchTerm = searchTerm.toLowerCase();
                let filtered = originalList.filter((item) =>  // Use allCountries here
                    item.name.toLowerCase().includes(searchTerm)
                );

                return filtered;
                }
        })

        const loadAll = () => {
            showAllItems.value = true
        }
        
        watch(
            search,
            (newVal, oldVal) => {
                showAllItems.value = false
            }
        )

        watch(
            () => [props.filterName, props.itemList, props.initialCount, props.loading],
            () => {
                init()
            }
        )

        onMounted(() => {
            init()
        })

        return {
            localName,
            localItemList,
            localInitialCount,
            localSelectedItems,
            localLoading,

            search,
            showAllItems,
            toggle,
            isSelected,
            displayedList,
            filteredList,
            loadAll
        }
        
    },
}
</script>


<style>

.panels-flat {
    color: var(--v-primary-base) !important;
    cursor:pointer;
  box-shadow: none !important;
  border-radius: 0% !important;
  z-index: unset  !important;
}

.list-item-small {
    max-height: 30px !important;
    min-height: 25px !important;
}

.custom-truncate-list-label  {

  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  width: 100%;
}

.custom-truncate-label .v-input__control .v-label {
    
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} 
</style>